export const POSITION_ACTION_TYPES = {
  SET_CLIENT_LIST: 'position/SET_CLIENT_LIST',
  SET_POSITION_STATEMENT: 'position/SET_POSITION_STATEMENT', 
}